module.exports = __webpack_public_path__ + "img/azure_ad_saml.0f50ca62.png";